//TextField
import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import TextField from "@mui/material/TextField";
import { ovHrV5Color } from "../config";


const styles = (theme) => ({
  label: {
    fontSize: "18px",
    fontWeight: 500,
  },
  toolbar: {
    backgroundColor: `${ovHrV5Color} !important`,
  },
  input: {
    fontSize: "15px",
    fontWeight: 500,
    borderRadius: 5,
    padding: "10px 15px",
  },
  labelColor: {
    color: "gray",
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: ovHrV5Color.main,
      },
    },
    "& .MuiFormLabel-root": {
      color: ovHrV5Color.main,
    },
    "& .MuiPickersToolbar-toolbar": {
      backgroundColor: ovHrV5Color.main,
    },
  },
});

const MyDatePicker = ({
  classes,
  styledemo,
  product,
  label,
  name,
  placeholder,
  onChange,
  value,
  disabled,
  disablePast,
  disableFuture,
  disableToday,
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setOpen(false);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleDatePickerOpen = () => setOpen(true);
  const handleDatePickerClose = () => setOpen(false);

  const disableDate = (date) => {
    const today = new Date();
    return disableToday && date.toDateString() === today.toDateString();
  };

  const combinedClassName = `${classes.textField} ${
    styledemo === 1
      ? classes.addroles
      : styledemo === 2
      ? classes.addtwo
      : styledemo === 3
      ? classes.addthree
      : ""
  }`;

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <DatePicker
        fullWidth
        classes={{ toolbar: classes.toolbar }}
        className={product === "HR" ? combinedClassName : ""}
        disablePast={disablePast || false}
        disableFuture={disableFuture || false}
        shouldDisableDate={disableDate}
        label={label}
        open={open}
        onOpen={handleDatePickerOpen}
        onClose={handleDatePickerClose}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        value={value || null}
        disabled={disabled}
        variant="inline"
        size="small"
        inputVariant="outlined"
        autoOk={true}
        format={"dd MMM yyyy"}
        renderInput={(params) => <TextField {...params} />}
      />
    </MuiPickersUtilsProvider>
  );
};

export default withStyles(styles)(MyDatePicker);